<template>
	<div class="libramiento puiformheader">
		<v-layout wrap>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('libramiento.mercancia')" :value="getMercancia"></pui-field>
			</v-flex>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('libramiento.terminalgestora')" :value="getTerminalgestora"></pui-field>
			</v-flex>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('libramiento.contrato')" :value="getContrato"></pui-field>
			</v-flex>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('libramiento.fecharecogida')" :value="getFecharecogida"></pui-field>
			</v-flex>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('libramiento.aplicacion')" :value="getAplicacion"></pui-field>
			</v-flex>
			<v-flex xs12 md4>
				<pui-field :label="this.$t('libramiento.comprador')" :value="getComprador"></pui-field>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import PuiFormHeaderMixin from 'pui9-mixins/PuiFormHeaderMixin';

export default {
	name: 'libramientotransformheader',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'libramientotrans'
		};
	},
	computed: {
		getMercancia() {
			return this.model && this.model.mercancia ? this.model.mercancia : '';
		},
		getTerminalgestora() {
			return this.model && this.model.terminalgestora ? this.model.terminalgestora : '';
		},
		getContrato() {
			return this.model && this.model.contrato ? this.model.contrato : '';
		},
		getComprador() {
			return this.model && this.model.comprador ? this.model.comprador : '';
		},
		getFecharecogida() {
			return this.model && this.model.fecharecogida
				? this.$dateTimeUtils.formatDate(this.model.fecharecogida, this.$store.getters.dateFormat)
				: '';
		},
		getPeso() {
			return this.model && this.model.pesosolicitado ? this.formatNumber(this.model.pesosolicitado) : '';
		},
		getAplicacion() {
			return this.model && this.model.aplicacion ? this.model.aplicacion : '';
		}
	},
	methods: {
		extendFilter(filter) {
			filter.model = 'libramientotrans';
		},
		formatNumber(val) {
			if (val === null) {
				return '';
			}
			const thousandSeparator = this.$store.getters.thousandSeparator;
			const decimalSeparator = this.$store.getters.decimalSeparator;
			if (val.toString().includes('.')) {
				const parts = val.toString().split('.');
				parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
				return parts.join(decimalSeparator);
			}
			return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`);
		}
	}
};
</script>
<style lang="postcss" scoped></style>
<i18n>
{
	"en": {
		"libramiento.mercancia": "Goods",
		"libramiento.fecharecogida": "Pick up date",
		"libramiento.peso": "Number of Kg.",
		"libramiento.contrato": "Contract",
		"libramiento.terminalgestora":"Management terminal",
		"libramiento.aplicacion":"Application",
		"libramiento.comprador":"Buyer",
		"libramiento.de": "From",
		"libramiento.a": "to"
	},
	"es": {
		"libramiento.mercancia": "Mercancía",
		"libramiento.fecharecogida": "Fecha de recogida",
		"libramiento.peso": "Nº Kg.",
		"libramiento.contrato": "Contrato",
		"libramiento.terminalgestora":"Terminal gestora",
		"libramiento.aplicacion":"Aplicación",
		"libramiento.comprador":"Comprador",
		"libramiento.de": "De",
		"libramiento.a": "a"
	},
	"ca": {
		"libramiento.mercancia": "Mercaderia",
		"libramiento.fecharecogida": "Data de recollida",
		"libramiento.peso": "Num. Kg.",
		"libramiento.contrato": "Contracte",
		"libramiento.terminalgestora":"Terminal gestora",
		"libramiento.aplicacion":"Aplicació",
		"libramiento.comprador":"Comprador",
		"libramiento.de": "De",
		"libramiento.a": "a"
	}
}
</i18n>
